import * as React from "react"
import styled from "styled-components"
import { ChildrenProps } from "../../@types/@core"
import { breakpoint, colors, scale } from "../../styles"
import { Flex } from "../Flex"
import { Icon, IconTypes } from "../Icon"
import { Text } from "../Text"

export interface CtaCardProps {
	icon?: IconTypes
	showCapioOnlineLink?: boolean
	capioOnlineLinkText?: string
	children?: React.ReactNode
}

export interface CtaCardComponent {
	Title: React.FC
	Preamble: React.FC
	Cta: React.FC
}

const CtaCardStyled = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: ${colors.blue11};
`

const CtaWrapper = styled.div`
	margin-block-start: auto;
`

const Description = styled(Text)`
	max-width: ${scale.px(51)};
`

const CtaCard: React.FC<CtaCardProps> & CtaCardComponent = ({
	icon,
	children,
}) => {
	return (
		<CtaCardStyled justify-content="center">
			<Flex
				flexDirection="column"
				alignItems="center"
				mt={scale.px(4)}
				mb={scale.px(4)}
				ml={scale.px(3)}
				mr={scale.px(3)}
				pt={icon ? 0 : { _: 5.75, l: 7 }}
			>
				{icon && <Icon size={{ _: 5.75, l: 7 }} mt={-1} mb={1} icon={icon} />}
				{children}
			</Flex>
		</CtaCardStyled>
	)
}

const Title: React.FC<ChildrenProps> = (props) => (
	<Text
		mb={1.375}
		variant={breakpoint("l") ? "headline-3" : "headline-4"}
		textAlign="center"
	>
		{props.children}
	</Text>
)

CtaCard.Title = Title

const Preamble: React.FC<ChildrenProps> = (props) => (
	<Description
		truncate="fourLine"
		mb={2.125}
		textAlign="center"
		variant="paragraph-16"
	>
		{props.children}
	</Description>
)

CtaCard.Preamble = Preamble

const Cta: React.FC<ChildrenProps> = (props) => (
	<CtaWrapper>{props.children}</CtaWrapper>
)

CtaCard.Cta = Cta

export { CtaCard }
